module.exports = __webpack_public_path__ + "img/jobMgt.4a33339f.svg";